export class ClubRessource {
    clubRessourceKey: number;
    clubCode: string;
    clubRessourceFirstName: string;
    clubRessourceLastName: string;
    clubRessourcePseudo: string;
    isActive: boolean;

    constructor(clubCode: string, clubRessourceFirstName: string, clubRessourceLastName: string, clubRessourcePseudo: string) {
        this.clubCode = clubCode;
        this.clubRessourceFirstName = clubRessourceFirstName;
        this.clubRessourceLastName = clubRessourceLastName;
        this.clubRessourcePseudo = clubRessourcePseudo;
    }
}
